module.exports = __webpack_public_path__ + "static/media/videoFilter.299a581c.png";